import { DownloadDprService } from './download-dpr.service';
import { DprReportService } from './dpr-report.service';
import { ReportActivitiesService } from './report-activities.service';
import { ReportOfEventLogService } from './report-of-event-log.service';
import { ReportStatusTrackerService } from './report-status-tracker.service';

export { DownloadDprService, DprReportService, ReportActivitiesService };

export const services = [
  DownloadDprService,
  DprReportService,
  ReportActivitiesService,
  ReportStatusTrackerService,
  ReportOfEventLogService,
];
